import * as tslib_1 from "tslib";
import { ShadowMethodBase } from "./ShadowMethodBase";
/**
 * ShadowHardMethod provides the cheapest shadow map method by using a single tap without any filtering.
 */
var ShadowHardMethod = (function (_super) {
    tslib_1.__extends(ShadowHardMethod, _super);
    function ShadowHardMethod() {
        return _super.apply(this, arguments) || this;
    }
    Object.defineProperty(ShadowHardMethod.prototype, "assetType", {
        /**
         * @inheritDoc
         */
        get: function () {
            return ShadowHardMethod.assetType;
        },
        enumerable: true,
        configurable: true
    });
    return ShadowHardMethod;
}(ShadowMethodBase));
export { ShadowHardMethod };
ShadowHardMethod.assetType = "[asset ShadowHardMethod]";



// WEBPACK FOOTER //
// ../dist/lib/methods/ShadowHardMethod.js